<!--中间框架页-->
<template>
  <div>
    <Header class="my-header"></Header>
    <keep-alive style="margin-top:60px">
      <router-view />
    </keep-alive>
    <Footer class="my-footer"></Footer>
  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
import {ieVersion} from '@/helper/device'
export default {
  name: 'index',
  data () {
    return {
      loading: true
    }
  },
  components: {
    Header,
    Footer
  },
  created(){
      var version = ieVersion();
      console.log(version);
      if(version > 0 && version < 10){
        this.$alert('此网站不再支持IE9及以下版本的浏览器，请使用最新的谷歌、IE11或微软Edge浏览器以获得更好的体验，谢谢！', '系统提醒', {
            confirmButtonText: '确定',
            callback: () => {
                //this.reload();
            }
        });

        this.$notify({
          title: '系统提醒',
          message: '此网站不再支持IE9及以下版本的浏览器，请使用最新的谷歌、IE11或微软Edge浏览器以获得更好的体验，谢谢！',
          duration: 0,
          type: 'warning',
          position: 'bottom-right',
          showClose: false
        });
      }
  },
  watch: {
    '$route' () {
    }
  }
}
</script>
<style scoped>
.my-header{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    margin-bottom: 60px;
    background: #ffffff;
}
</style>
